import { GroupContextType } from '../../utils/groupContextType';
import { useShortcutMenu } from '../hooks/useShortcutMenu';

import { CustomerGroupSelection } from './GroupContext/CustomerGroupSelection';
import { GroupTypeSelection } from './GroupContext/GroupTypeSelection';
import { SupplierGroupSelection } from './GroupContext/SupplierGroupSelection';

export const GroupContextAction = () => {
    const { groupContextActionType } = useShortcutMenu();

    if (!groupContextActionType) {
        return <GroupTypeSelection />;
    }

    if (groupContextActionType === GroupContextType.CUSTOMER_GROUP) {
        return <CustomerGroupSelection />;
    }

    return <SupplierGroupSelection />;
};
